import Breadcrumbs from 'Components/Breadcrumbs'
import CustomButton from 'Components/CustomButton'
import ListActions from 'Components/ListActions'
import PageTitle from 'Components/PageTitle'
import BulkTicketSaleDrawer from 'Services/SalesManagement/Features/TicketSale/Components/BulkTicketSaleDrawer'
import BulkTicketSaleList from 'Services/SalesManagement/Features/TicketSale/Components/BulkTicketSaleList'
import useTicketSalesParams from 'Services/SalesManagement/Features/TicketSale/Hooks/useTicketSalesParams'
import { useGetBulkTicketSalesQuery } from 'Services/SalesManagement/Features/TicketSale/ticketSaleApi'
import useListPage from 'Services/SalesManagement/Hooks/useListPage'
import useSalesManagementBreadcrumbs from 'Services/SalesManagement/Hooks/useSalesManagementBreadcrumbs'
import { SALES_MANAGEMENT_ROOT_URL } from 'Util/constants'
import AddIcon from '@mui/icons-material/Add'
import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { t } from 'ttag'

export default function BulkTicketSaleListPage() {
  const navigate = useNavigate()
  const baseUrl = `${SALES_MANAGEMENT_ROOT_URL}/ticket-sales/bulk-ticket-sales`
  const title = t`Bulk ticket sales`

  const { params, setParams, selectedTicketSaleId, setSelectedTicketSaleId } =
    useTicketSalesParams()
  const { data, isFetching } = useGetBulkTicketSalesQuery(params)

  const breadcrumbs = useSalesManagementBreadcrumbs([
    {
      title: t`Ticket sales`
    },
    { title }
  ])
  const { isDrawerOpen, handleRowClick, handleDrawerClose, handleChangePage } = useListPage({
    selectedId: selectedTicketSaleId,
    setSelectedId: setSelectedTicketSaleId,
    params,
    setParams
  })

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ mb: 2 }}>
        <Breadcrumbs items={breadcrumbs} />
        <PageTitle>{title}</PageTitle>
        <Typography component="p" variant="subtitle1" sx={{ fontSize: '15px', mb: 4 }}>
          {t`Bulk ticket sales are intended for the sale of large quantities of tickets.`}
        </Typography>
      </Box>
      <ListActions>
        <CustomButton
          onClick={() => navigate(`${baseUrl}/create`)}
          size="small"
          startIcon={<AddIcon />}
        >
          {t`Sell bulk tickets`}
        </CustomButton>
      </ListActions>
      <BulkTicketSaleList
        rows={data?.results ?? []}
        isLoading={isFetching}
        onRowClick={handleRowClick}
        selectedBulkTicketSaleId={selectedTicketSaleId}
        handleChangePage={handleChangePage}
        count={data?.count ?? 0}
        page={params.page - 1}
      />
      <BulkTicketSaleDrawer
        open={isDrawerOpen}
        handleClose={handleDrawerClose}
        selectedBulkTicketSaleId={selectedTicketSaleId}
      />
    </Box>
  )
}
